import React from "react";
import Navbar from "./Navbar";
import Hero from "./Hero";
import TechStack from "./TechStack";
import WorkExp from "./WorkExp";
import Projects from "./Projects";
import Contact from "./Contact";

function HomePage() {
  return (
    <div className="container px-3 px-md-5">
      <div className="row px-md-5">
        <div className="col-lg-2"></div>
        <div className="col-lg-8">
          <Navbar />
          <Hero />
          <TechStack />
          {/* <WorkExp /> */}
          <Projects />
          <Contact />
          <footer>© {new Date().getFullYear()} Tanveer Singh</footer>
        </div>
        <div className="col-lg-2"></div>
      </div>
    </div>
  );
}

export default HomePage;


